import { useQuery } from '@tanstack/react-query';
import secureLocalStorage from 'react-secure-storage';
import { serverRequest } from '../../util/server_request';
import { extractErrorMessage } from '../extractErrorMessage';
import { notifyUser } from '../../util/util';

const notifiedErrors = new Set();

const notifyOnce = (type, message, title = '') => {
  if (!notifiedErrors.has(message)) {
    notifiedErrors.add(message);
    notifyUser(type, message, title);
  }
};

export function useCompanySearch(searchTerm) {
  return useQuery({
    queryKey: ['company-search', searchTerm],
    enabled: !!secureLocalStorage.getItem('token') && Boolean(searchTerm && searchTerm.length >= 2),
    staleTime: 60 * 1000,
    queryFn: async () => {
      const response = await serverRequest(
        'PUT',
        `search-company?search=${searchTerm ?? ''}`
      );

      if (!response || !response.success) {
        throw new Error(response?.message || 'Failed to search companies');
      }

      return Array.isArray(response.data) ? response.data : [];
    },
    onError: (error) => {
      const message = extractErrorMessage(error, 'Failed to search companies');
      notifyOnce('error', message, 'Search Error');
    }
  });
}
